module.exports = __webpack_public_path__ + "BisericaBaptistaSperanta-Logo.png?59d12bf76da9a80953addc42eb82fdc5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/BisericaBaptistaSperanta-Logo.png
// module id = 167
// module chunks = 0